module.exports = __webpack_public_path__ + "img/icon-school8.b32a150f.png";